function setQueryParams(urlString, params = {}) {
    if(!urlString) return
    const url = new URL(urlString)

    Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined) {
            url.searchParams.delete(key)
        } else {
            url.searchParams.set(key, value)
        }
    })

    return url.toString()
}

module.exports = setQueryParams